import {
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MapService } from '@lassi/webapp-shared';
import { Control, ControlPosition, DomEvent, Map as LeafletMap } from 'leaflet';

@Directive({
  selector: '[lassiLeafletControl]',
  standalone: true,
})
export class LeafletControlDirective implements OnDestroy, OnInit {
  private readonly ref = inject(ElementRef);
  private readonly mapService = inject(MapService);

  position = input.required<ControlPosition>();
  order = input.required<number>();

  constructor() {
    effect(() => {
      this.control.setPosition(this.position());
    });

    effect(() => {
      const order = this.order();

      this.control.getContainer()?.style.setProperty('order', order.toString());
    });
  }

  ngOnInit() {
    this.mapService.addControl(this.control);
  }

  ngOnDestroy() {
    this.control.remove();
  }

  private _map: LeafletMap | undefined;

  public get map() {
    if (this._map) {
      return this._map;
    }
    throw new Error('Map not ready');
  }

  public control = new (Control.extend({
    onAdd: (map: LeafletMap) => {
      this._map = map;
      DomEvent.disableClickPropagation(this.ref.nativeElement);
      DomEvent.disableScrollPropagation(this.ref.nativeElement);
      return this.ref.nativeElement;
    },
    onRemove: (_map: LeafletMap) => {
      //
    },
  }))();
}

export const LEAFLET_CONTROL_DIRECTIVE = {
  directive: LeafletControlDirective,
  inputs: ['position', 'order'],
};
